import React from 'react';
import './App.css';
import {bootstrap, zoneAdded} from "./store/notificationsSlice";
import {connect} from "react-redux";
import {useEffect} from "react";
import Loader from 'react-loader-spinner';
import AddZone from "./containers/AddZone/AddZone";
import {Switch, Route} from "react-router";
import {makeStyles} from "@material-ui/core";
import MainScreen from "./containers/MainScreen/MainScreen";

const useStyles = makeStyles(theme => ({
	App: {
		display: 'flex',
	},
	Content: {
		flexGrow: 1
	}
}));

function App(props) {
	const css = useStyles();

	useEffect(() => {
		props.fetchNotifications();
		// eslint-disable-next-line
	}, []);

	if( !props.bootstrapped )
		return (<div className='Loader'><Loader
			type="Puff"
			color="#00BFFF"
			height={100}
			width={100}
			timeout={3000} //3 secs
		/></div>);
	// TrackChanges

	//https://maps.googleapis.com/maps/api/js?key=AIzaSyBkNaAGLEVq0YLQMi-PYEMabFeREadYe1Q&v=3.exp&libraries=geometry,drawing,places",
	return (
		<div className={css.App} style={{height: '100%'}}>

			<div className={css.Content}>
				<Switch>
					<Route path='/add-zone' component={AddZone} />
					<Route path='/alert/:alertId'>
						<MainScreen />
					</Route>
					<Route path='/'>
						<MainScreen />
					</Route>
				</Switch>
			</div>
		</div>
	);
}
//		    <div key={n.notification_id}>{n.latitude}, {n.longitude}</div>
const mapStateToProps = (state) => {
	return {
      zones: state.notifications.zones,
		bootstrapped: state.core.bootstrapped
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
	  fetchNotifications: () => dispatch(bootstrap()),
      addNotification: (notification) => dispatch(zoneAdded(notification))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
